import {
    createColumnsDict,
    Table,
    TABLE_COLUMN_SIZING_FN,
    TableColumn,
    TableColumnConfig,
    TableColumnsDefMap,
    TableColumnsSizingStep
} from '../../components/tables/table';
import {DisplayTxHistoryRec} from './display-tx-history-rec';

export type DexTxHistoryTable = Table<DexTxHistoryTableColumnKey, DisplayTxHistoryRec>;

export enum DexTxHistoryTableColumnKey {
    HASH       = 'HASH',
    ORDER_ID   = 'ORDER_ID',
    METHOD     = 'METHOD',
    SENT       = 'SENT',
    RECEIVED   = 'RECEIVED',
    PRICE      = 'PRICE',
    FEE        = 'FEE',
    GAS        = 'GAS',
    ACCOUNT    = 'ACCOUNT',
    CREATED_AT = 'CREATED_AT',
    UPDATED_AT = 'UPDATED_AT',
    STATUS     = 'STATUS'
}

export enum DexTxHistoryTableSizeGroup {
    HASH,
    ORDER_ID,
    METHOD,
    SENT,
    RECEIVED,
    PRICE,
    FEE,
    GAS,
    ACCOUNT,
    CREATED_AT,
    UPDATED_AT,
    STATUS
}

export interface DexTxHistoryTableColumn extends TableColumn {
    key: DexTxHistoryTableColumnKey;
}

export interface DexTxHistoryTableColumnConfig extends TableColumnConfig {
    key: DexTxHistoryTableColumnKey;
}

export const DEX_TX_HISTORY_TABLE_COLUMNS_DEF: DexTxHistoryTableColumn[] = [
    {
        label:       'Order ID', // TODO: locale
        key:         DexTxHistoryTableColumnKey.ORDER_ID,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.ORDER_ID
    },
    {
        label:       'Hash', // TODO: locale
        key:         DexTxHistoryTableColumnKey.HASH,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.HASH
    },
    {
        label:       'Type', // TODO: locale
        key:         DexTxHistoryTableColumnKey.METHOD,
        isRequired:  true,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.METHOD
    },
    {
        label:       'Sent', // TODO: locale
        key:         DexTxHistoryTableColumnKey.SENT,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.SENT
    },
    {
        label:       'Received', // TODO: locale
        key:         DexTxHistoryTableColumnKey.RECEIVED,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.RECEIVED
    },
    {
        label:       'Price', // TODO: locale
        key:         DexTxHistoryTableColumnKey.PRICE,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.PRICE
    },
    {
        label:       'Fee', // TODO: locale
        key:         DexTxHistoryTableColumnKey.FEE,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.FEE
    },
    {
        label:       'Gas', // TODO: locale
        key:         DexTxHistoryTableColumnKey.GAS,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.GAS
    },
    {
        label:       'Account', // TODO: locale
        key:         DexTxHistoryTableColumnKey.ACCOUNT,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.ACCOUNT
    },
    {
        label:       'Created', // TODO: locale
        key:         DexTxHistoryTableColumnKey.CREATED_AT,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.CREATED_AT
    },
    {
        label:       'Updated', // TODO: locale
        key:         DexTxHistoryTableColumnKey.UPDATED_AT,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.UPDATED_AT
    },
    {
        label:       'Status', // TODO: locale
        key:         DexTxHistoryTableColumnKey.STATUS,
        width:       '10%',
        sizeGroupId: DexTxHistoryTableSizeGroup.STATUS
    }
] as const;

export const DEX_TX_HISTORY_TABLE_COLUMNS_DICT:
    TableColumnsDefMap<DexTxHistoryTableColumnKey, DexTxHistoryTableColumn> =
        createColumnsDict(DEX_TX_HISTORY_TABLE_COLUMNS_DEF);

const DEX_TX_HISTORY_COLUMN_SIZE_GROUPS: DexTxHistoryTableSizeGroup[] = [
    DexTxHistoryTableSizeGroup.HASH,
    DexTxHistoryTableSizeGroup.ORDER_ID,
    DexTxHistoryTableSizeGroup.METHOD,
    DexTxHistoryTableSizeGroup.SENT,
    DexTxHistoryTableSizeGroup.RECEIVED,
    DexTxHistoryTableSizeGroup.PRICE,
    DexTxHistoryTableSizeGroup.FEE,
    DexTxHistoryTableSizeGroup.GAS,
    DexTxHistoryTableSizeGroup.ACCOUNT,
    DexTxHistoryTableSizeGroup.STATUS,
    DexTxHistoryTableSizeGroup.CREATED_AT,
    DexTxHistoryTableSizeGroup.UPDATED_AT
] as const;

export const DEX_TX_HISTORY_TABLE_COLUMNS_SIZING: Array<TableColumnsSizingStep<DexTxHistoryTableSizeGroup>> = [
    ...DEX_TX_HISTORY_COLUMN_SIZE_GROUPS.map<TableColumnsSizingStep<DexTxHistoryTableSizeGroup>>(
        sizeGroupId => ({
            sizeGroupId,
            getGroupSize: TABLE_COLUMN_SIZING_FN.fixedWidth(10)
        })),
    ...DEX_TX_HISTORY_COLUMN_SIZE_GROUPS.map<TableColumnsSizingStep<DexTxHistoryTableSizeGroup>>(
        sizeGroupId => ({
            sizeGroupId,
            getGroupSize: TABLE_COLUMN_SIZING_FN.lazyFitContent()
        })),
    ...DEX_TX_HISTORY_COLUMN_SIZE_GROUPS.map<TableColumnsSizingStep<DexTxHistoryTableSizeGroup>>(
        sizeGroupId => ({
            sizeGroupId,
            getGroupSize: TABLE_COLUMN_SIZING_FN.lazyFitContent(30)
        })),
    ...DEX_TX_HISTORY_COLUMN_SIZE_GROUPS.map<TableColumnsSizingStep<DexTxHistoryTableSizeGroup>>(
        sizeGroupId => ({
            sizeGroupId,
            getGroupSize: TABLE_COLUMN_SIZING_FN.lazyFitContent(100)
        })),
    {
        sizeGroupId:  DexTxHistoryTableSizeGroup.METHOD,
        getGroupSize: TABLE_COLUMN_SIZING_FN.stretch()
    }
] as const;
